var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.marketgroup && _vm.marketgroup.idfwmarketgroup
    ? _c(
        "div",
        {
          staticClass: "marketgroup clearfix",
          class: ["counter-" + _vm.counter, _vm.className],
          attrs: {
            fluid: "",
            idfwmarketgroup: _vm.marketgroup.idfwmarketgroup.toString()
          }
        },
        [
          _vm.isheadlinecoupon
            ? _c(
                "div",
                {
                  staticClass: "headline-coupon-markets",
                  class: [
                    _vm.headlineCouponSport,
                    {
                      "show-more-button": _vm.headlineCouponMoreThan3Selections
                    }
                  ],
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return function() {
                        _vm.goToEvent(_vm.headlineCouponEvent)
                        _vm.sendGTMEventBanner(_vm.headline)
                      }.apply(null, arguments)
                    }
                  }
                },
                [
                  !_vm.headline.headline.imageurl
                    ? _c("div", {
                        staticClass: "background",
                        class:
                          "font-icon font-icon-" +
                          _vm.headlineCouponSport
                            .split(" ")
                            .join("")
                            .toLowerCase()
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "headline-coupon-header" }, [
                    _c("h2", { staticClass: "text-overflow" }, [
                      _vm._v(_vm._s(_vm.headlineCouponHeading))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "time" },
                      [
                        _vm.filteredLiveEvents.length
                          ? [
                              _c("span", { staticClass: "live-box" }, [
                                _vm._v("LIVE")
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.filteredLiveEvents.length
                          ? [
                              _vm.isDateToday(_vm.headlineCouponTime)
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BettingOffer.Today")) +
                                        " " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.headlineCouponEvent.tsstart,
                                            _vm.dateFormats.longTime
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isDateTomorrow(_vm.headlineCouponTime)
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("BettingOffer.Tomorrow")
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.headlineCouponEvent.tsstart,
                                            _vm.dateFormats.longTime
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isDateToday(_vm.headlineCouponTime) &&
                              !_vm.isDateTomorrow(_vm.headlineCouponTime)
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.headlineCouponTime,
                                          _vm.dateFormats.shortDateTime
                                        )
                                      ) + " "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "market-name" }, [
                    _vm.headlineCouponMarketName
                      ? _c("span", { staticClass: "text-overflow" }, [
                          _vm._v(_vm._s(_vm.headlineCouponMarketName))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "event-name text-overflow" }, [
                      _vm._v(_vm._s(_vm.headlineCouponEvent.eventname))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.filteredLiveEvents.length
                    ? _c(
                        "div",
                        { staticClass: "coupon live-headline-coupon" },
                        [
                          _c("big3-markets-header", {
                            attrs: {
                              coupontitle: _vm.headlineCouponEvent.eventname,
                              idfosporttype: _vm.getIDFOSportType(
                                _vm.headlineCouponEvent
                              ),
                              "is-big3-coupon": _vm.isBig3Coupon([
                                _vm.headlineCouponEvent
                              ]),
                              "has-draw": _vm.hasDraw([
                                _vm.headlineCouponEvent
                              ]),
                              "max-no-of-markets": _vm.maxNumberOfMarkets([
                                _vm.headlineCouponEvent
                              ]),
                              "max-no-of-selections": _vm.maxNumberOfSelections(
                                [_vm.headlineCouponEvent]
                              ),
                              isoutright:
                                [_vm.headlineCouponEvent] &&
                                _vm.headlineCouponEvent &&
                                _vm.headlineCouponEvent.markets &&
                                _vm.headlineCouponEvent.markets[0] &&
                                _vm.headlineCouponEvent.markets[0].isoutright
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event" },
                            [
                              _c("live-event-info", {
                                attrs: {
                                  event: _vm.liveEvents.find(function(
                                    liveEvent
                                  ) {
                                    return (
                                      liveEvent.idfoevent ===
                                      _vm.headlineCouponEvent.idfoevent
                                    )
                                  }),
                                  page: "coupon",
                                  isbig3coupon: _vm.isBig3Coupon([
                                    _vm.headlineCouponEvent
                                  ]),
                                  twoselections:
                                    !_vm.isBig3Coupon([
                                      _vm.headlineCouponEvent
                                    ]) &&
                                    !_vm.hasDraw([_vm.headlineCouponEvent]),
                                  threeselections:
                                    !_vm.isBig3Coupon([
                                      _vm.headlineCouponEvent
                                    ]) &&
                                    _vm.hasDraw([_vm.headlineCouponEvent]),
                                  couponname: _vm.headlineCouponEvent.eventname
                                }
                              }),
                              _vm._v(" "),
                              _vm.headlineCouponEvent.markets
                                ? _c("markets", {
                                    staticClass: "markets",
                                    attrs: {
                                      markets: _vm.isBig3Coupon([
                                        _vm.headlineCouponEvent
                                      ])
                                        ? _vm.headlineCouponEvent.markets
                                        : [_vm.headlineCouponEvent.markets[0]],
                                      event: _vm.headlineCouponEvent,
                                      maxnumofmarkets: "3",
                                      iscoupondisplay: true,
                                      pricechangehighlight: true,
                                      diplayOnPage: "prematch-event",
                                      isbig3coupon: _vm.isBig3Coupon([
                                        _vm.headlineCouponEvent
                                      ]),
                                      couponname:
                                        _vm.headlineCouponEvent.eventname
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filteredPrematchEvents.length
                    ? _c(
                        "div",
                        { staticClass: "coupon prematch-headline-coupon" },
                        [
                          _c("big3-markets-header", {
                            attrs: {
                              coupontitle: _vm.headlineCouponEvent.eventname,
                              idfosporttype: _vm.getIDFOSportType(
                                _vm.headlineCouponEvent
                              ),
                              "is-big3-coupon": _vm.isBig3Coupon([
                                _vm.headlineCouponEvent
                              ]),
                              "has-draw": _vm.hasDraw([
                                _vm.headlineCouponEvent
                              ]),
                              "max-no-of-markets": _vm.maxNumberOfMarkets([
                                _vm.headlineCouponEvent
                              ]),
                              "max-no-of-selections": _vm.maxNumberOfSelections(
                                [_vm.headlineCouponEvent]
                              ),
                              isoutright:
                                [_vm.headlineCouponEvent] &&
                                _vm.headlineCouponEvent &&
                                _vm.headlineCouponEvent.markets &&
                                _vm.headlineCouponEvent.markets[0] &&
                                _vm.headlineCouponEvent.markets[0].isoutright
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event" },
                            [
                              _c("coupon-event", {
                                attrs: {
                                  event: _vm.headlineCouponEvent,
                                  twoselections:
                                    !_vm.isBig3Coupon([
                                      _vm.headlineCouponEvent
                                    ]) &&
                                    !_vm.hasDraw([_vm.headlineCouponEvent]),
                                  threeselections:
                                    !_vm.isBig3Coupon([
                                      _vm.headlineCouponEvent
                                    ]) &&
                                    _vm.hasDraw([_vm.headlineCouponEvent]),
                                  isbig3coupon: _vm.isBig3Coupon([
                                    _vm.headlineCouponEvent
                                  ]),
                                  couponname: _vm.headlineCouponEvent.eventname
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "headline-coupon-buttons" },
                    [
                      _c("v-btn", { staticClass: "more-button" }, [
                        _vm._v(_vm._s(_vm.$t("More")))
                      ])
                    ],
                    1
                  )
                ]
              )
            : _c(
                "div",
                [
                  _vm.showMarketgroupName
                    ? _c(
                        "h3",
                        {
                          staticClass: "name",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleCollapse()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.marketgroup.marketgroupname) + " ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isParlayBuilderMarketGroup
                    ? [
                        ["EVENTSPERCOMPETITION", "EVENTSPERDAY"].indexOf(
                          _vm.eventsGrouping
                        ) > -1 &&
                        (_vm.eventsGroupedByCompetition.length > 0 ||
                          _vm.eventsGroupedByDateAndCompetition ||
                          _vm.liveEventsPerSportGroupedByIDFOSport.length > 0)
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isExpanded,
                                    expression: "isExpanded"
                                  }
                                ],
                                staticClass: "coupon group-by-date"
                              },
                              [
                                _vm.isDebug
                                  ? [
                                      _vm._v(
                                        "\n        eventsGrouping : " +
                                          _vm._s(_vm.eventsGrouping) +
                                          "\n        "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.liveEventsPerSportGroupedByIDFOSport,
                                  function(fosport, sportIndex) {
                                    return !_vm.hideliveevents
                                      ? _c(
                                          "div",
                                          {
                                            key: fosport.idfosport,
                                            staticClass: "date live"
                                          },
                                          [
                                            _vm.isDebug
                                              ? [
                                                  _vm._v(
                                                    "\n            fosportinternalorder " +
                                                      _vm._s(
                                                        fosport.fosportinternalorder
                                                      ) +
                                                      "\n            isBig3Coupon " +
                                                      _vm._s(
                                                        _vm.isBig3Coupon(
                                                          fosport.events
                                                        )
                                                      ) +
                                                      "\n          "
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            fosport.isLive === "live"
                                              ? [
                                                  _c("big3-markets-header", {
                                                    attrs: {
                                                      coupontitle:
                                                        fosport.fosportname ||
                                                        _vm.marketgroup
                                                          .marketgroupname,
                                                      idfosporttype: _vm.getIDFOSportType(
                                                        fosport.events[0]
                                                      ),
                                                      "is-big3-coupon": _vm.isBig3Coupon(
                                                        fosport.events
                                                      ),
                                                      "has-draw": _vm.hasDraw(
                                                        fosport.events
                                                      ),
                                                      "max-no-of-markets": _vm.maxNumberOfMarkets(
                                                        fosport.events
                                                      ),
                                                      "max-no-of-selections": _vm.maxNumberOfSelections(
                                                        fosport.events
                                                      ),
                                                      isoutright:
                                                        fosport.events &&
                                                        fosport.events[0] &&
                                                        fosport.events[0]
                                                          .markets &&
                                                        fosport.events[0]
                                                          .markets[0] &&
                                                        fosport.events[0]
                                                          .markets[0].isoutright
                                                    }
                                                  })
                                                ]
                                              : [
                                                  _c("big3-markets-header", {
                                                    attrs: {
                                                      coupontitle:
                                                        _vm.marketgroup
                                                          .idfwpopulationtype ===
                                                        "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                          ? fosport.fosportname
                                                          : _vm.marketgroup
                                                              .marketgroupname,
                                                      idfosporttype: _vm.getIDFOSportType(
                                                        fosport.events[0]
                                                      ),
                                                      "is-big3-coupon": _vm.isBig3Coupon(
                                                        fosport.events
                                                      ),
                                                      "has-draw": _vm.hasDraw(
                                                        fosport.events
                                                      ),
                                                      "max-no-of-markets": _vm.maxNumberOfMarkets(
                                                        fosport.events
                                                      ),
                                                      "max-no-of-selections": _vm.maxNumberOfSelections(
                                                        fosport.events
                                                      ),
                                                      isoutright:
                                                        fosport.events &&
                                                        fosport.events[0] &&
                                                        fosport.events[0]
                                                          .markets &&
                                                        fosport.events[0]
                                                          .markets[0] &&
                                                        fosport.events[0]
                                                          .markets[0].isoutright
                                                    }
                                                  })
                                                ],
                                            _vm._v(" "),
                                            _vm._l(fosport.events, function(
                                              event,
                                              eventIndex
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: event.idfoevent,
                                                  staticClass: "event",
                                                  class: [
                                                    event.idfosporttype,
                                                    {
                                                      last:
                                                        eventIndex ===
                                                        fosport.events.length -
                                                          1,
                                                      first: eventIndex === 0
                                                    }
                                                  ]
                                                },
                                                [
                                                  [
                                                    "GOLF",
                                                    "MOTORSPORT",
                                                    "NASCAR"
                                                  ].indexOf(
                                                    fosport.events[0].markets[0]
                                                      .selections[0]
                                                      .idfosporttype
                                                  ) > -1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "outright-golf outright-event-name hheader"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              event.eventname
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  [
                                                    "GOLF",
                                                    "MOTORSPORT",
                                                    "NASCAR"
                                                  ].indexOf(
                                                    fosport.events[0].markets[0]
                                                      .selections[0]
                                                      .idfosporttype
                                                  ) > -1 &&
                                                  _vm.showOutrightMarketname
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "outright-golf outright-event-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              event.markets[0]
                                                                .name
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info-markets-container",
                                                      class: {
                                                        tennis:
                                                          fosport.fosportname ===
                                                          "Tennis",
                                                        soccer:
                                                          fosport.fosportname ===
                                                          "Soccer",
                                                        GOLF:
                                                          fosport.events[0]
                                                            .markets[0]
                                                            .selections[0]
                                                            .idfosporttype ===
                                                          "GOLF",
                                                        MOTORSPORT:
                                                          fosport.events[0]
                                                            .markets[0]
                                                            .selections[0]
                                                            .idfosporttype ===
                                                          "MOTORSPORT",
                                                        NASCAR:
                                                          fosport.events[0]
                                                            .markets[0]
                                                            .selections[0]
                                                            .idfosporttype ===
                                                          "NASCAR",
                                                        MMA:
                                                          fosport.events[0]
                                                            .markets[0]
                                                            .selections[0]
                                                            .idfosporttype ===
                                                          "MMA"
                                                      }
                                                    },
                                                    [
                                                      _c("live-event-info", {
                                                        attrs: {
                                                          event: _vm.liveEvents.find(
                                                            function(
                                                              liveEvent
                                                            ) {
                                                              return (
                                                                liveEvent.idfoevent ===
                                                                event.idfoevent
                                                              )
                                                            }
                                                          ),
                                                          page: "coupon",
                                                          isbig3coupon: _vm.isBig3Coupon(
                                                            fosport.events
                                                          ),
                                                          twoselections:
                                                            !_vm.isBig3Coupon(
                                                              fosport.events
                                                            ) &&
                                                            !_vm.hasDraw(
                                                              fosport.events
                                                            ),
                                                          threeselections:
                                                            !_vm.isBig3Coupon(
                                                              fosport.events
                                                            ) &&
                                                            _vm.hasDraw(
                                                              fosport.events
                                                            ),
                                                          couponname:
                                                            fosport.fosportname ||
                                                            _vm.marketgroup
                                                              .marketgroupname
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      event.markets
                                                        ? _c("markets", {
                                                            staticClass:
                                                              "markets",
                                                            attrs: {
                                                              markets:
                                                                event.markets,
                                                              event: event,
                                                              maxnumofmarkets:
                                                                "3",
                                                              iscoupondisplay: true,
                                                              pricechangehighlight: true,
                                                              diplayOnPage:
                                                                "prematch-event",
                                                              isbig3coupon: _vm.isBig3Coupon(
                                                                fosport.events
                                                              ),
                                                              couponname:
                                                                fosport.fosportname ||
                                                                _vm.marketgroup
                                                                  .marketgroupname
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !event.markets
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "nomarkets"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Sports.NoAvailableMarkets"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.mobileBigAndBelow &&
                                                      _vm.brandLayout !==
                                                        "generic" &&
                                                      _vm.brandKey !== "sb" &&
                                                      _vm.brandKey !== "mav" &&
                                                      _vm.brandKey !== "qcasino"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "more-markets morebets",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.goToEvent(
                                                                    event
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "chevron_right"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  [
                                                    "GOLF",
                                                    "MOTORSPORT",
                                                    "NASCAR"
                                                  ].indexOf(
                                                    event.markets[0]
                                                      .idfosporttype
                                                  ) === -1 ||
                                                  !event.markets ||
                                                    event.markets.length ===
                                                      0 ||
                                                  (event.markets[0]
                                                    .selections &&
                                                    event.markets[0].selections
                                                      .length <= 9)
                                                    ? _c(
                                                        "live-coupon-event-footer",
                                                        {
                                                          attrs: {
                                                            event: _vm.liveEvents.find(
                                                              function(
                                                                liveEvent
                                                              ) {
                                                                return (
                                                                  liveEvent.idfoevent ===
                                                                  event.idfoevent
                                                                )
                                                              }
                                                            ),
                                                            couponname:
                                                              fosport.fosportname ||
                                                              _vm.marketgroup
                                                                .marketgroupname
                                                          }
                                                        }
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  }
                                ),
                                _vm._v(" "),
                                _vm.isDebug
                                  ? [
                                      _vm._v(
                                        "\n          eventsGrouping : " +
                                          _vm._s(_vm.eventsGrouping) +
                                          "\n        "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.eventsGroupedByCompetition, function(
                                  fosport,
                                  index
                                ) {
                                  return _vm.eventsGrouping ===
                                    "EVENTSPERCOMPETITION"
                                    ? _c(
                                        "div",
                                        { key: index, staticClass: "date" },
                                        [
                                          _vm.isDebug
                                            ? [
                                                _vm._v(
                                                  "\n            fosportinternalorder " +
                                                    _vm._s(
                                                      fosport.fosportinternalorder
                                                    ) +
                                                    "\n            isBig3Coupon " +
                                                    _vm._s(
                                                      _vm.isBig3Coupon(
                                                        fosport.events
                                                      )
                                                    ) +
                                                    "\n          "
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          fosport.events[0].markets[0]
                                            .isoutright
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-expansion-panel",
                                                    {
                                                      staticClass:
                                                        "market-collapse",
                                                      attrs: {
                                                        value:
                                                          _vm.counter === 0
                                                            ? 0
                                                            : 1
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-expansion-panel-content",
                                                        {
                                                          attrs: {
                                                            id: [
                                                              "market-" +
                                                                _vm.counter
                                                            ]
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "panel-header",
                                                              attrs: {
                                                                slot: "header"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.togglePanel(
                                                                    _vm.counter
                                                                  )
                                                                }
                                                              },
                                                              slot: "header"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "market-name",
                                                                  class: [
                                                                    {
                                                                      "expanded-market":
                                                                        _vm.counter ===
                                                                        0
                                                                    }
                                                                  ]
                                                                },
                                                                [
                                                                  _c(
                                                                    "big3-markets-header",
                                                                    {
                                                                      attrs: {
                                                                        coupontitle: _vm.formatCouponTitle(
                                                                          fosport,
                                                                          _vm
                                                                            .marketgroup
                                                                            .marketgroupname,
                                                                          _vm
                                                                            .marketgroup
                                                                            .idfwpopulationtype,
                                                                          _vm
                                                                            .marketgroup
                                                                            .idfwmarketgroup
                                                                        ),
                                                                        idfosporttype: _vm.getIDFOSportType(
                                                                          fosport
                                                                            .events[0]
                                                                        ),
                                                                        "is-big3-coupon": _vm.isBig3Coupon(
                                                                          fosport.events
                                                                        ),
                                                                        "has-draw": _vm.hasDraw(
                                                                          fosport.events
                                                                        ),
                                                                        "max-no-of-markets": _vm.maxNumberOfMarkets(
                                                                          fosport.events
                                                                        ),
                                                                        "max-no-of-selections": _vm.maxNumberOfSelections(
                                                                          fosport.events
                                                                        ),
                                                                        isoutright: true
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "flex icon-span"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "expand_more_icon",
                                                                          style:
                                                                            _vm.counter ===
                                                                            0
                                                                              ? {
                                                                                  display:
                                                                                    "none"
                                                                                }
                                                                              : {},
                                                                          attrs: {
                                                                            id: [
                                                                              "market-expand-" +
                                                                                _vm.counter
                                                                            ]
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "expand_more"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "expand_less_icon",
                                                                          style:
                                                                            _vm.counter >
                                                                            0
                                                                              ? {
                                                                                  display:
                                                                                    "none"
                                                                                }
                                                                              : {},
                                                                          attrs: {
                                                                            id: [
                                                                              "market-collapsed-" +
                                                                                _vm.counter
                                                                            ]
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "expand_less"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            fosport.events,
                                                            function(
                                                              event,
                                                              $index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: $index,
                                                                  class: [
                                                                    "event",
                                                                    {
                                                                      last:
                                                                        $index ===
                                                                        fosport
                                                                          .events
                                                                          .length -
                                                                          1
                                                                    },
                                                                    {
                                                                      first:
                                                                        $index ===
                                                                        0
                                                                    },
                                                                    {
                                                                      "big-three-one-selection-per-event":
                                                                        _vm.isBig3Coupon(
                                                                          fosport.events
                                                                        ) &&
                                                                        _vm.maxNumberOfMarkets(
                                                                          fosport.events
                                                                        ) === 1
                                                                    }
                                                                  ]
                                                                },
                                                                [
                                                                  _c(
                                                                    "coupon-event",
                                                                    {
                                                                      attrs: {
                                                                        event: event,
                                                                        twoselections:
                                                                          !_vm.isBig3Coupon(
                                                                            fosport.events
                                                                          ) &&
                                                                          !_vm.hasDraw(
                                                                            fosport.events
                                                                          ),
                                                                        threeselections:
                                                                          !_vm.isBig3Coupon(
                                                                            fosport.events
                                                                          ) &&
                                                                          _vm.hasDraw(
                                                                            fosport.events
                                                                          ),
                                                                        isbig3coupon: _vm.isBig3Coupon(
                                                                          fosport.events
                                                                        ),
                                                                        couponname:
                                                                          _vm
                                                                            .marketgroup
                                                                            .idfwpopulationtype ===
                                                                          "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                                            ? fosport.fosportname
                                                                            : _vm
                                                                                .marketgroup
                                                                                .marketgroupname
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("big3-markets-header", {
                                                    attrs: {
                                                      coupontitle: _vm.formatCouponTitle(
                                                        fosport,
                                                        _vm.marketgroup
                                                          .marketgroupname,
                                                        _vm.marketgroup
                                                          .idfwpopulationtype,
                                                        _vm.marketgroup
                                                          .idfwmarketgroup
                                                      ),
                                                      idfosporttype: _vm.getIDFOSportType(
                                                        fosport.events[0]
                                                      ),
                                                      "is-big3-coupon": _vm.isBig3Coupon(
                                                        fosport.events
                                                      ),
                                                      "has-draw": _vm.hasDraw(
                                                        fosport.events
                                                      ),
                                                      "max-no-of-markets": _vm.maxNumberOfMarkets(
                                                        fosport.events
                                                      ),
                                                      "max-no-of-selections": _vm.maxNumberOfSelections(
                                                        fosport.events
                                                      ),
                                                      isoutright: false
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    fosport.events,
                                                    function(event, $index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: $index,
                                                          class: [
                                                            "event",
                                                            {
                                                              last:
                                                                $index ===
                                                                fosport.events
                                                                  .length -
                                                                  1
                                                            },
                                                            {
                                                              first:
                                                                $index === 0
                                                            },
                                                            {
                                                              "big-three-one-selection-per-event":
                                                                _vm.isBig3Coupon(
                                                                  fosport.events
                                                                ) &&
                                                                _vm.maxNumberOfMarkets(
                                                                  fosport.events
                                                                ) === 1
                                                            }
                                                          ]
                                                        },
                                                        [
                                                          _c("coupon-event", {
                                                            attrs: {
                                                              event: event,
                                                              twoselections:
                                                                !_vm.isBig3Coupon(
                                                                  fosport.events
                                                                ) &&
                                                                !_vm.hasDraw(
                                                                  fosport.events
                                                                ),
                                                              threeselections:
                                                                !_vm.isBig3Coupon(
                                                                  fosport.events
                                                                ) &&
                                                                _vm.hasDraw(
                                                                  fosport.events
                                                                ),
                                                              isbig3coupon: _vm.isBig3Coupon(
                                                                fosport.events
                                                              ),
                                                              couponname:
                                                                _vm.marketgroup
                                                                  .idfwpopulationtype ===
                                                                "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                                  ? fosport.fosportname
                                                                  : _vm
                                                                      .marketgroup
                                                                      .marketgroupname
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.eventsGroupedByDateAndCompetition,
                                  function(dateEvents, date, iterator) {
                                    return _vm.eventsGrouping === "EVENTSPERDAY"
                                      ? _c(
                                          "div",
                                          {
                                            key: iterator,
                                            staticClass: "date"
                                          },
                                          [
                                            _vm.isDateToday(date)
                                              ? _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "eventsperday_header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BettingOffer.Today"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isDateTomorrow(date)
                                              ? _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "eventsperday_header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BettingOffer.Tomorrow"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isDateToday(date) &&
                                            !_vm.isDateTomorrow(date)
                                              ? _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "eventsperday_header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          date,
                                                          _vm.dateFormats
                                                            .shortDateMG
                                                        )
                                                      ) + " "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._l(dateEvents, function(
                                              fosport,
                                              index
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "date-events"
                                                },
                                                [
                                                  _vm.isDebug
                                                    ? [
                                                        _vm._v(
                                                          "\n              fosportinternalorder " +
                                                            _vm._s(
                                                              fosport.fosportinternalorder
                                                            ) +
                                                            "\n              isBig3Coupon " +
                                                            _vm._s(
                                                              _vm.isBig3Coupon(
                                                                fosport.events
                                                              )
                                                            ) +
                                                            "\n            "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !fosport.events[0].markets[0]
                                                    .isoutright
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "big3-markets-header",
                                                            {
                                                              attrs: {
                                                                coupontitle: _vm.formatCouponTitle(
                                                                  fosport,
                                                                  _vm
                                                                    .marketgroup
                                                                    .marketgroupname,
                                                                  _vm
                                                                    .marketgroup
                                                                    .idfwpopulationtype,
                                                                  _vm
                                                                    .marketgroup
                                                                    .idfwmarketgroup
                                                                ),
                                                                idfosporttype: _vm.getIDFOSportType(
                                                                  fosport
                                                                    .events[0]
                                                                ),
                                                                "is-big3-coupon": _vm.isBig3Coupon(
                                                                  fosport.events
                                                                ),
                                                                "has-draw": _vm.hasDraw(
                                                                  fosport.events
                                                                ),
                                                                "max-no-of-markets": _vm.maxNumberOfMarkets(
                                                                  fosport.events
                                                                ),
                                                                "max-no-of-selections": _vm.maxNumberOfSelections(
                                                                  fosport.events
                                                                ),
                                                                isoutright: false
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            fosport.events,
                                                            function(
                                                              event,
                                                              $index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: $index,
                                                                  class: [
                                                                    "event",
                                                                    {
                                                                      last:
                                                                        $index ===
                                                                        fosport
                                                                          .events
                                                                          .length -
                                                                          1
                                                                    },
                                                                    {
                                                                      first:
                                                                        $index ===
                                                                        0
                                                                    },
                                                                    {
                                                                      "big-three-one-selection-per-event":
                                                                        _vm.isBig3Coupon(
                                                                          fosport.events
                                                                        ) &&
                                                                        _vm.maxNumberOfMarkets(
                                                                          fosport.events
                                                                        ) === 1
                                                                    }
                                                                  ]
                                                                },
                                                                [
                                                                  _c(
                                                                    "coupon-event",
                                                                    {
                                                                      attrs: {
                                                                        event: event,
                                                                        twoselections:
                                                                          !_vm.isBig3Coupon(
                                                                            fosport.events
                                                                          ) &&
                                                                          !_vm.hasDraw(
                                                                            fosport.events
                                                                          ),
                                                                        threeselections:
                                                                          !_vm.isBig3Coupon(
                                                                            fosport.events
                                                                          ) &&
                                                                          _vm.hasDraw(
                                                                            fosport.events
                                                                          ),
                                                                        isbig3coupon: _vm.isBig3Coupon(
                                                                          fosport.events
                                                                        ),
                                                                        couponname:
                                                                          _vm
                                                                            .marketgroup
                                                                            .marketgroupname
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  fosport.events[0].markets[0]
                                                    .isoutright
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "v-expansion-panel",
                                                            {
                                                              staticClass:
                                                                "market-collapse",
                                                              attrs: {
                                                                value:
                                                                  iterator === 0
                                                                    ? 0
                                                                    : 1
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-expansion-panel-content",
                                                                {
                                                                  attrs: {
                                                                    id: [
                                                                      "market-" +
                                                                        iterator
                                                                    ]
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "panel-header",
                                                                      attrs: {
                                                                        slot:
                                                                          "header"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.togglePanel(
                                                                            iterator
                                                                          )
                                                                        }
                                                                      },
                                                                      slot:
                                                                        "header"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "market-name",
                                                                          class: [
                                                                            {
                                                                              "expanded-market":
                                                                                iterator ===
                                                                                0
                                                                            }
                                                                          ]
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "big3-markets-header",
                                                                            {
                                                                              attrs: {
                                                                                coupontitle: _vm.formatCouponTitle(
                                                                                  fosport,
                                                                                  _vm
                                                                                    .marketgroup
                                                                                    .marketgroupname,
                                                                                  _vm
                                                                                    .marketgroup
                                                                                    .idfwpopulationtype,
                                                                                  _vm
                                                                                    .marketgroup
                                                                                    .idfwmarketgroup
                                                                                ),
                                                                                idfosporttype: _vm.getIDFOSportType(
                                                                                  fosport
                                                                                    .events[0]
                                                                                ),
                                                                                "is-big3-coupon": _vm.isBig3Coupon(
                                                                                  fosport.events
                                                                                ),
                                                                                "has-draw": _vm.hasDraw(
                                                                                  fosport.events
                                                                                ),
                                                                                "max-no-of-markets": _vm.maxNumberOfMarkets(
                                                                                  fosport.events
                                                                                ),
                                                                                "max-no-of-selections": _vm.maxNumberOfSelections(
                                                                                  fosport.events
                                                                                ),
                                                                                isoutright: true
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "flex icon-span"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  staticClass:
                                                                                    "expand_more_icon",
                                                                                  style:
                                                                                    iterator ===
                                                                                    0
                                                                                      ? {
                                                                                          display:
                                                                                            "none"
                                                                                        }
                                                                                      : {},
                                                                                  attrs: {
                                                                                    id: [
                                                                                      "market-expand-" +
                                                                                        iterator
                                                                                    ]
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "expand_more"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  staticClass:
                                                                                    "expand_less_icon",
                                                                                  style:
                                                                                    iterator >
                                                                                    0
                                                                                      ? {
                                                                                          display:
                                                                                            "none"
                                                                                        }
                                                                                      : {},
                                                                                  attrs: {
                                                                                    id: [
                                                                                      "market-collapsed-" +
                                                                                        iterator
                                                                                    ]
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "expand_less"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    fosport.events,
                                                                    function(
                                                                      event,
                                                                      $index
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: $index,
                                                                          class: [
                                                                            "event",
                                                                            {
                                                                              last:
                                                                                $index ===
                                                                                fosport
                                                                                  .events
                                                                                  .length -
                                                                                  1
                                                                            },
                                                                            {
                                                                              first:
                                                                                $index ===
                                                                                0
                                                                            },
                                                                            {
                                                                              "big-three-one-selection-per-event":
                                                                                _vm.isBig3Coupon(
                                                                                  fosport.events
                                                                                ) &&
                                                                                _vm.maxNumberOfMarkets(
                                                                                  fosport.events
                                                                                ) ===
                                                                                  1
                                                                            }
                                                                          ]
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "coupon-event",
                                                                            {
                                                                              attrs: {
                                                                                event: event,
                                                                                twoselections:
                                                                                  !_vm.isBig3Coupon(
                                                                                    fosport.events
                                                                                  ) &&
                                                                                  !_vm.hasDraw(
                                                                                    fosport.events
                                                                                  ),
                                                                                threeselections:
                                                                                  !_vm.isBig3Coupon(
                                                                                    fosport.events
                                                                                  ) &&
                                                                                  _vm.hasDraw(
                                                                                    fosport.events
                                                                                  ),
                                                                                isbig3coupon: _vm.isBig3Coupon(
                                                                                  fosport.events
                                                                                ),
                                                                                couponname:
                                                                                  _vm
                                                                                    .marketgroup
                                                                                    .marketgroupname
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  }
                                )
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.eventsGrouping === "NONGROUPEDEVENTS" &&
                        (_vm.filteredPrematchEvents ||
                          _vm.filteredLiveEvents.length > 0)
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isExpanded,
                                    expression: "isExpanded"
                                  }
                                ],
                                staticClass: "coupon non-grouped"
                              },
                              [
                                _vm.filteredLiveEvents.length > 0
                                  ? _c("h4", { staticClass: "live-date" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.filteredLiveEvents.length)
                                        )
                                      ]),
                                      _vm._v(_vm._s(_vm.$t("Sports.Live")))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filteredLiveEvents.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isExpanded,
                                            expression: "isExpanded"
                                          }
                                        ],
                                        staticClass: "live-events"
                                      },
                                      _vm._l(_vm.filteredLiveEvents, function(
                                        event,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index, staticClass: "event" },
                                          [
                                            _c("live-event-info", {
                                              attrs: {
                                                event: _vm.liveEvents.find(
                                                  function(liveEvent) {
                                                    return (
                                                      liveEvent.idfoevent ===
                                                      event.idfoevent
                                                    )
                                                  }
                                                ),
                                                page: "coupon",
                                                couponname:
                                                  _vm.marketgroup
                                                    .marketgroupname
                                              }
                                            }),
                                            _vm._v(" "),
                                            event.markets
                                              ? _c("markets", {
                                                  attrs: {
                                                    markets: event.markets,
                                                    event: event,
                                                    maxnumofmarkets: "3",
                                                    iscoupondisplay: true,
                                                    pricechangehighlight: true,
                                                    diplayOnPage: "marketGroup",
                                                    couponname:
                                                      _vm.marketgroup
                                                        .marketgroupname
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !event.markets
                                              ? _c(
                                                  "div",
                                                  { staticClass: "nomarkets" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Sports.NoAvailableMarkets"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filteredPrematchEvents[0] &&
                                _vm.filteredPrematchEvents[0].markets[0]
                                  .isoutright
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "v-expansion-panel",
                                          {
                                            staticClass: "market-collapse",
                                            attrs: {
                                              value: _vm.counter === 0 ? 0 : 1
                                            }
                                          },
                                          [
                                            _c(
                                              "v-expansion-panel-content",
                                              {
                                                attrs: {
                                                  id: ["market-" + _vm.counter]
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "panel-header",
                                                    attrs: { slot: "header" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.togglePanel(
                                                          _vm.counter
                                                        )
                                                      }
                                                    },
                                                    slot: "header"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "market-name",
                                                        class: [
                                                          {
                                                            "expanded-market":
                                                              _vm.counter === 0
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        _c(
                                                          "big3-markets-header",
                                                          {
                                                            attrs: {
                                                              coupontitle:
                                                                _vm.marketgroup
                                                                  .idfwpopulationtype ===
                                                                "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                                  ? _vm.fosport
                                                                      .fosportname
                                                                  : _vm
                                                                      .marketgroup
                                                                      .marketgroupname,
                                                              idfosporttype: _vm.getIDFOSportType(
                                                                _vm
                                                                  .filteredPrematchEvents[0]
                                                              ),
                                                              "is-big3-coupon": _vm.isBig3Coupon(
                                                                _vm.filteredPrematchEvents
                                                              ),
                                                              "has-draw": _vm.hasDraw(
                                                                _vm.filteredPrematchEvents
                                                              ),
                                                              "max-no-of-markets": _vm.maxNumberOfMarkets(
                                                                _vm.filteredPrematchEvents
                                                              ),
                                                              "max-no-of-selections": _vm.maxNumberOfSelections(
                                                                _vm.filteredPrematchEvents
                                                              ),
                                                              isoutright: true
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "flex icon-span"
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "expand_more_icon",
                                                                style:
                                                                  _vm.counter ===
                                                                  0
                                                                    ? {
                                                                        display:
                                                                          "none"
                                                                      }
                                                                    : {},
                                                                attrs: {
                                                                  id: [
                                                                    "market-expand-" +
                                                                      _vm.counter
                                                                  ]
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "expand_less"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "expand_less_icon",
                                                                style:
                                                                  _vm.counter >
                                                                  0
                                                                    ? {
                                                                        display:
                                                                          "none"
                                                                      }
                                                                    : {},
                                                                attrs: {
                                                                  id: [
                                                                    "market-collapsed-" +
                                                                      _vm.counter
                                                                  ]
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "expand_more"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.filteredPrematchEvents,
                                                  function(event, $index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: $index,
                                                        class: [
                                                          "event",
                                                          {
                                                            last:
                                                              $index ===
                                                              _vm
                                                                .filteredPrematchEvents
                                                                .length -
                                                                1
                                                          },
                                                          {
                                                            first: $index === 0
                                                          },
                                                          {
                                                            "big-three-one-selection-per-event":
                                                              _vm.isBig3Coupon(
                                                                _vm.filteredPrematchEvents
                                                              ) &&
                                                              _vm.maxNumberOfMarkets(
                                                                _vm.filteredPrematchEvents
                                                              ) === 1
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        _c("coupon-event", {
                                                          attrs: {
                                                            event: event,
                                                            twoselections:
                                                              !_vm.isBig3Coupon(
                                                                _vm.filteredPrematchEvents
                                                              ) &&
                                                              !_vm.hasDraw(
                                                                _vm.filteredPrematchEvents
                                                              ),
                                                            threeselections:
                                                              !_vm.isBig3Coupon(
                                                                _vm.filteredPrematchEvents
                                                              ) &&
                                                              _vm.hasDraw(
                                                                _vm.filteredPrematchEvents
                                                              ),
                                                            isbig3coupon: _vm.isBig3Coupon(
                                                              _vm.filteredPrematchEvents
                                                            ),
                                                            couponname:
                                                              _vm.marketgroup
                                                                .idfwpopulationtype ===
                                                              "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                                ? _vm.fosport
                                                                    .fosportname
                                                                : _vm
                                                                    .marketgroup
                                                                    .marketgroupname
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("big3-markets-header", {
                                          attrs: {
                                            coupontitle:
                                              _vm.marketgroup.marketgroupname,
                                            idfosporttype: _vm.getIDFOSportType(
                                              _vm.filteredPrematchEvents[0]
                                            ),
                                            "is-big3-coupon": _vm.isBig3Coupon(
                                              _vm.filteredPrematchEvents
                                            ),
                                            "has-draw": _vm.hasDraw(
                                              _vm.filteredPrematchEvents
                                            ),
                                            "max-no-of-markets": _vm.maxNumberOfMarkets(
                                              _vm.filteredPrematchEvents
                                            ),
                                            "max-no-of-selections": _vm.maxNumberOfSelections(
                                              _vm.filteredPrematchEvents
                                            ),
                                            isoutright: false
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.filteredPrematchEvents,
                                          function(event, $index) {
                                            return _c(
                                              "div",
                                              {
                                                key: $index,
                                                class: [
                                                  "event",
                                                  {
                                                    last:
                                                      $index ===
                                                      _vm.filteredPrematchEvents
                                                        .length -
                                                        1
                                                  },
                                                  { first: $index === 0 },
                                                  {
                                                    "big-three-one-selection-per-event":
                                                      _vm.isBig3Coupon(
                                                        _vm.filteredPrematchEvents
                                                      ) &&
                                                      _vm.maxNumberOfMarkets(
                                                        _vm.filteredPrematchEvents
                                                      ) === 1
                                                  }
                                                ]
                                              },
                                              [
                                                _c("coupon-event", {
                                                  attrs: {
                                                    event: event,
                                                    twoselections:
                                                      !_vm.isBig3Coupon(
                                                        _vm.filteredPrematchEvents
                                                      ) &&
                                                      !_vm.hasDraw(
                                                        _vm.filteredPrematchEvents
                                                      ),
                                                    threeselections:
                                                      !_vm.isBig3Coupon(
                                                        _vm.filteredPrematchEvents
                                                      ) &&
                                                      _vm.hasDraw(
                                                        _vm.filteredPrematchEvents
                                                      ),
                                                    isbig3coupon: _vm.isBig3Coupon(
                                                      _vm.filteredPrematchEvents
                                                    ),
                                                    couponname:
                                                      _vm.marketgroup
                                                        .marketgroupname
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    )
                              ]
                            )
                          : _vm._e()
                      ]
                    : [
                        _c("parlay-builder", {
                          attrs: {
                            marketGroup: _vm.marketgroup,
                            selectedSports: _vm.selectedSports
                          }
                        })
                      ]
                ],
                2
              )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f59d14fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f59d14fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/marketGroup.vue
// module id = null
// module chunks = 